import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {SerieService} from "./serieService";
import {AppStateService} from "../../services/appStateService";

export class SerieUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private serieService: SerieService;
    private appStateService: AppStateService;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.serieService = new SerieService();
        this.appStateService = new AppStateService();

        this.initializeModal();
        this.populatePreview();
    }

    private initializeModal()
    {
        var closeButton = null;
        const seriesConfiguratorComponent = document.querySelector('.configuratorComponent[nf-component-name="series"]');

        if (seriesConfiguratorComponent !== null) {
            closeButton = seriesConfiguratorComponent.querySelector(`[nf-action="closeSerieDetailsModal"]`);
        }
        if (closeButton !== null) {
            closeButton.addEventListener('click', (event: any) => {
                this.appStateService.setAppSettingTemplateFlag('series', 'serieDetailsModal', false);
                this.uiService.refreshElementsInModule('series');
            });
        }
    }

    private populatePreview()
    {
        const previewSerie = this.uiService.getElementByActionName('preview-series');
        const selectedSerieId = this.productDataStore.getSelectedOptionIdByName('series');
        const allSeries = this.productDataStore.getAvailableOptionsByName(
            'series'
        );

        previewSerie.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });

        allSeries.some((serie) => {
            if (selectedSerieId === serie.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            serie.attributes.name
                        )
                    );

                    previewSerie.forEach((previewSerieElement) => {
                    previewSerieElement.append(element);
                });
                return true;
            }
        });
    }

    private openSerieDetails(serieId)
    {
        let serieDetails = document.querySelector('.configuratorOptionCardListingItem[nf-option-name="serie"][nf-option-id="' + serieId + '"]');

        if (serieDetails) {
            serieDetails.classList.add('--opened-item');
        }
    }

    private closeAllSeriesDetails()
    {
        let seriesDetails = document.querySelectorAll('.configuratorOptionCardListingItem[nf-option-name="serie"]');

        seriesDetails.forEach((element) => {
            element.classList.remove('--opened-item');
        });
    }

    public initializeSeriesComponent()
    {
        let series = this.productDataStore.getAvailableOptionsByName('series');
        series = series.filter(serie => serie.hiddenSerie == false);

        series.forEach((serie) => {
            const option = this.createSerieOption(serie);
            const selectSerieBtn = option.querySelector(`[nf-action="selectSerie"]`);

            if (serie.id === this.productDataStore.getSelectedOptionIdByName('series')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                var isOpened = option.classList.contains('--opened-item');
                var isChecked = option.classList.contains('--checked-item');

                this.closeAllSeriesDetails();

                if (!isOpened && !isChecked) {
                    this.openSerieDetails(serie.id);
                }
            });
            if (selectSerieBtn !== null) {
                selectSerieBtn.addEventListener('click', (event: any) => {
                    this.productDataService.reloadProductWithNewSerie(serie.id);
                });
            }
        });
    }

    private createSerieOption(serie)
    {
        const option = this.uiService.createConfiguratorOption('serie');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            serie.id
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'title', option),
            'src',
            serie.attributes.title);

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'name', option),
            serie.attributes.name
        );

        if (serie.attributes.basePriceDifference.raw !== 0) {
            var priceDifferenceText = '';

            if (serie.attributes.basePriceDifference.raw > 0) {
                priceDifferenceText += '+';
            }
            priceDifferenceText += serie.attributes.basePriceDifference.formatted;

            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute('nf-value-key', 'price', option),
                priceDifferenceText
            );
        }

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'img', option),
            'src',
            serie.attributes.imgSrc);

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'imgJpeg', option),
            'srcset',
            serie.attributes.imgSrc);

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'imgWebp', option),
            'srcset',
            serie.attributes.imgWebpSrc);

        this.uiService.addHtmlInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'details', option),
            serie.attributes.details);

        return option;
    }
}
